import { defineMessages } from 'react-intl';

export const transactionTypeMessages = defineMessages({
  FundsAdded: {
    description: 'FundsAdded transaction type label',
    defaultMessage: 'Funds Added',
    id: '861ATC',
  },
  Adjustment: {
    description: 'Adjustment transaction type label',
    defaultMessage: 'Adjustment',
    id: 'baFuKi',
  },
  Refund: {
    description: 'Refund transaction type label',
    defaultMessage: 'Refund',
    id: 'U0sSOn',
  },
  Credit: {
    description: 'Credit transaction type label',
    defaultMessage: 'Credit',
    id: 'wIPUuz',
  },
  Debit: {
    description: 'Debit transaction type label ',
    defaultMessage: 'Debit',
    id: 'x2zOmP',
  },
  Label: {
    description: 'Label transaction type label ',
    defaultMessage: 'Label',
    id: 'yhn/R5',
  },
  ServiceCharge: {
    description: 'ServiceCharge transaction type label ',
    defaultMessage: 'Service Charge',
    id: 'qf6elL',
  },
  Insurance: {
    description: 'Insurance transaction type label',
    defaultMessage: 'Insurance',
    id: 'avDR2b',
  },
  Unknown: {
    description: 'Unknown transaction type label',
    defaultMessage: 'Unknown',
    id: 'U3w8Tk',
  },
  DutiesAndTaxes: {
    description: 'DutiesAndTaxes transaction type label',
    defaultMessage: 'Duties & Taxes',
    id: 'x03fLI',
  },
});

const specialLineItemMessages = defineMessages({
  Label: {
    description: 'title for a expense line item that describes the amount of money related to a Label purchase',
    defaultMessage: 'Label Cost',
    id: 'MJsMGR',
  },
  Insurance: {
    description: 'title for a expense line item that describes the amount of money related to an Insurance purchase',
    defaultMessage: 'Insurance Cost',
    id: 'TITAkk',
  },
});

export const lineItemMessages = {
  ...transactionTypeMessages,
  ...specialLineItemMessages,
};

export default defineMessages({
  transactionHistory: {
    description: 'Title for the page displaying the history of transactions',
    defaultMessage: 'Transaction History',
    id: '+FGvxV',
  },
  transactionDetails: {
    description: 'Title for the modal/pop-up displaying the details of a transaction',
    defaultMessage: 'Transaction Details',
    id: 'Z/sPid',
  },
  balance: {
    description: "Label for the user's account balance",
    defaultMessage: 'Balance',
    id: 'j4WpnN',
  },
  download: {
    description: 'Label for the link to download the invoice',
    defaultMessage: 'Download',
    id: 'HT1GM0',
  },
  invoiceDefaultName: {
    description: 'Default name for the invoice file when downloaded',
    defaultMessage: 'Invoice',
    id: '8EWFwj',
  },
  subscription: {
    description: 'Label for tab displaying a transactions table of charges related to an accounts subscription to Shipstation',
    defaultMessage: 'Subscription',
    id: 'SIOUKV',
  },
  type: {
    description: 'Label for the category/type a Transaction belongs to',
    defaultMessage: 'Type',
    id: '2ajlZE',
  },
  dateRange: {
    description: 'Label for a date range filter input',
    defaultMessage: 'Date Range',
    id: 'c0BsL/',
  },
  transactionId: {
    description: 'Label for text representing a single Transaction Id',
    defaultMessage: 'Transaction ID',
    id: '62DjM9',
  },
  orderHeader: {
    description: 'Label for text representing a order/purchase Id',
    defaultMessage: 'Order',
    id: '3zvNUO',
  },
  orderLabel: {
    description: 'Label for text representing 1 or more order/purchase Ids',
    defaultMessage: '{count, plural, one {Order Number} other {Order Numbers}}',
    id: '9RX1rA',
  },
  shipmentHeader: {
    description: 'Label for text representing a shipment/delivery Id',
    defaultMessage: 'Shipment',
    id: 'Z7mAa2',
  },
  shipmentLabel: {
    description: 'Label for text representing 1 or more shipment/delivery Ids',
    defaultMessage: '{count, plural, one {Shipment Number} other {Shipment Numbers}}',
    id: '83aMSV',
  },
  dateHeader: {
    description: 'Label for the date and time the transaction took place',
    defaultMessage: 'Date',
    id: '+evnxY',
  },
  dateLabel: {
    description: 'Label for the date and time a transaction took place',
    defaultMessage: 'Transaction Date',
    id: 'Ne87OR',
  },
  costHeader: {
    description: 'Label for the cost of a transaction',
    defaultMessage: 'Cost',
    id: 'KnhuNl',
  },
  costBreakdown: {
    description: "Label for the itemized breakdown of a transaction's cost",
    defaultMessage: 'Cost Breakdown',
    id: 'IlaqB2',
  },
  costTotal: {
    description: "Label for the sum of a transaction's itemized cost",
    defaultMessage: 'Cost Total',
    id: 'usI9hC',
  },
  creditHeader: {
    description: 'Label for the credit/funds added of a transaction',
    defaultMessage: 'Credit',
    id: 'pSVu+f',
  },
  creditBreakdown: {
    description: "Label for the itemized breakdown of a transaction's credit/funds added",
    defaultMessage: 'Credit Breakdown',
    id: '1S2hBW',
  },
  creditTotal: {
    description: "Label for the sum of a transaction's itemized credit/funds added",
    defaultMessage: 'Credit Total',
    id: '3prCuw',
  },
  adjustmentBreakdown: {
    description: 'label for the list of reasons for cost adjustments made to a users shipment',
    defaultMessage: 'Adjustment Breakdown',
    id: '5qhO2E',
  },
  adjustmentTotal: {
    description: 'label for showing a total of the adjusted cost',
    defaultMessage: 'Total',
    id: 'KYIA3e',
  },
  amountAdjusted: {
    description: 'label showing how much the shipment cost was adjusted',
    defaultMessage: 'Amount Adjusted',
    id: 'N5NSuH',
  },
  carrier: {
    description: 'Label for the carrier used in a label transaction',
    defaultMessage: '{count, plural, one {Carrier} other {Carriers}}',
    id: 'ZScwNp',
  },
  tracking: {
    description: 'Label for the tracking information associated in a label purchase',
    defaultMessage: 'Tracking',
    id: 'vSnN4S',
  },
  adjustmentId: {
    description: 'Label for the id an adjustment transaction',
    defaultMessage: 'Adjustment Id',
    id: 'DB+NUW',
  },
  insuranceProvider: {
    description: 'Label for the insurance provider used in an insurance transaction',
    defaultMessage: 'Insurance Provider',
    id: '6fs5yn',
  },
  exportLinkText: {
    description: 'text for the link to the export page',
    defaultMessage: 'Export Balance History',
    id: 'FIoDJS',
  },
  placeholderTitle: {
    description: 'title for the transaction grid placeholder',
    defaultMessage: 'No transactions found',
    id: 'pnR/d4',
  },
  placeholderDescription: {
    description: 'Label for describing why no transaction information is being shown. Displayed below "No transactions found"',
    defaultMessage: 'Transactions related to your account history will appear here.',
    id: 'pE+Y7e',
  },
  errorLoadingDetailsTitle: {
    description: 'title for notification when loading details fails.',
    defaultMessage: 'Transaction details not found',
    id: 'z57Y4a',
  },
  errorLoadingDetailsContent: {
    description: 'content for notification when loading details fails',
    defaultMessage: 'Unable to load the details for that transaction. Please try again.',
    id: 'pAhtih',
  },
  invoicesDisclaimer: {
    description: 'disclaimer at top of grid on invoice page',
    defaultMessage:
      'Invoices covering your subscription history as billed by ShipStation. Please direct any questions regarding billing to our <supportLink>Support team</supportLink>',
    id: '35ioN+',
  },
  namedWalletBalance: {
    description: 'Tab content when user has multiple "wallets" setup',
    defaultMessage: 'Balance - {nickname}',
    id: 'WE6q0c',
  },
  resetFilters: {
    description: 'Button label to remove/clear all existing search filters',
    defaultMessage: 'Reset Filters',
    id: 'CA5l1q',
  },
  transactionHistoryExportNotifStartHeader: {
    description: 'The header for the notification toast that is displayed when the user clicks the Export link',
    defaultMessage: 'Exporting Transaction History',
    id: 'z9aHcr',
  },
  transactionHistoryExportNotifStartBody: {
    description: 'The text displayed in the notification toast when the user clicks the export link',
    defaultMessage: 'Your Transaction History Export is being generated.',
    id: 'AqY925',
  },
  transactionHistoryExportNotifDoneHeader: {
    description: 'The header for the notification toast when the export is in progress',
    defaultMessage: 'Transaction History Export Complete',
    id: '/3jAQj',
  },
  transactionHistoryExportNotifDoneBody: {
    description: 'The text displayed in the notification toast when the export is in progress',
    defaultMessage: 'Your Transaction History Export will be downloaded automatically.',
    id: 'b5kAEi',
  },
  transactionHistoryExportNotifErrorHeader: {
    description: 'The header for the notification toast that is displayed when there is an error exporting the report',
    defaultMessage: 'Transaction History Export Error',
    id: '0LUiJj',
  },
  transactionHistoryExportNotifErrorBody: {
    description: 'The text displayed in the notification toast when there is an error exporting the report',
    defaultMessage: 'An error occurred while attempting to export. Please try again.',
    id: 'H2L6UU',
  },
  defaultAdjustmentReason: {
    description: 'an adjustment reason that will be shown if we do not have a reason attached to this adjustment',
    defaultMessage: 'Adjustment determined by carrier.',
    id: 'xRENP+',
  },
});
